import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';
import './SelectCityDlg.css';

const styles = (theme) => ({
  bg: {
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingTop: '20px',
    paddingLeft: '20px',
    paddingRight: '20px',
  },
  entryPointModalContainer: {
    display: 'none', //display: 'none',
    position: 'fixed' /* Stay in place */,
    zIndex: 1300 /* Sit on top */,
    left: 0,
    top: 0,
    width: '100vw' /* Full width */,
    // height: '100vh' /* Full height */,
    height: '100%' /* Full height */,
    overflowY: 'none', //overflowY: 'none' /* Enable scroll if needed */,
    //backgroundColor: 'rgb(0,0,0)' /* Fallback color */,
    backgroundColor: 'rgba(0,0,0,0.5)' /* Black w/ opacity */,
  },
  modalDiv: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  entryPointModal: {
    display: 'flex',
    margin: '0 auto',
    width: 'calc(100% - 64px)',
    maxWidth: '600px',
    maxHeight: 'calc(100% - 40px)',
    borderRadius: '4px',
    boxShadow: '0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)',
  },
  modalCloseBtn: {
    width: 'calc(100% - 64px)',
    maxWidth: '600px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

class SelectCityDlg extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  getCodeToName(code) {
    if (code === 'seoul') {
      return '서울특별시';
    } else if (code === 'gygg') {
      return '경기도';
    } else if (code === 'incheon') {
      return '인천광역시';
    } else if (code === 'gangwon') {
      return '강원도';
    } else if (code === 'chungbuk') {
      return '충청북도';
    } else if (code === 'chungnam') {
      return '충청남도';
    } else if (code === 'jeonbuk') {
      return '전라북도';
    } else if (code === 'daejeon') {
      return '대전광역시';
    } else if (code === 'jeonbuk') {
      return '전라북도';
    } else if (code === 'gwangju') {
      return '광주광역시';
    } else if (code === 'jeonnam') {
      return '전라남도';
    } else if (code === 'gyeongbuk') {
      return '경상북도';
    } else if (code === 'daegu') {
      return '대구광역시';
    } else if (code === 'gyeongnam') {
      return '경상남도';
    } else if (code === 'ulsan') {
      return '울산광역시';
    } else if (code === 'busan') {
      return '부산광역시';
    } else if (code === 'jeju') {
      return '제주도';
    }
  }

  modalClose = () => {
    document.getElementById('modalContainerM').style.display = 'none';
    document.body.style.overflowY = 'inherit';
    if (
      navigator.userAgent.match(/mobile/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/^(safari|(?!chrome).)*$/gi)
    ) {
      document.body.style.overflow = 'inherit';
    }
    this.props.modalClose();
  };

  onClickLoadItem = (id) => {
    window.selected = 'none';
    document.body.style.overflowY = 'inherit';

    this.props.history.push(`/mypage?course=${id}`);
  };

  render() {
    const { classes } = this.props;

    return (
      <div
        id="modalContainerM"
        className={classes.entryPointModalContainer}
        style={{ display: this.props.showDialog ? 'block' : 'none', overflowY: this.props.showDialog ? 'hidden' : 'inherit' }}
      >
        <div className={classes.modalDiv}>
          <div className={classes.modalCloseBtn}>
            <CloseIcon
              onClick={() => {
                this.modalClose();
              }}
              style={{ color: '#fff', cursor: 'pointer', width: '1.5em', height: '1.5em' }}
              // style={{ position: 'absolute', right: '1em', top: '1em', cursor: 'pointer' }}
            />
          </div>
          <div className={classes.entryPointModal}>
            <div
              id="city_list"
              style={{ display: 'flex', flex: '1', flexDirection: 'column', alignItems: 'center', marginBottom: '15px', overflowY: 'auto' }}
            >
              {this.props.drawData[this.props.selected] ? (
                <div>
                  <div
                    style={{
                      background: this.props.drawData[this.props.selected].firstColor,
                      height: '30px',
                      padding: '5px',
                      borderRadius: '15px 15px 0px 15px',
                      color: '#000000',
                      fontWeight: 900,
                      marginBottom: '5px',
                      width: '180px',
                      textAlign: 'center',
                    }}
                  >
                    {this.getCodeToName(this.props.selected)}
                  </div>
                  <div style={{}}>
                    {this.props.list[this.props.selected].map((data) => {
                      return (
                        <div
                          className="city"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            this.onClickLoadItem(data.id);
                          }}
                          key={'' + data.id}
                        >
                          {data.name}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(SelectCityDlg));
